

import ApiService from "../../../../utils/apiService";
import { PAYMENT_TYPE_MEMBERSHIP } from "../../../../utils/constants"

export const getUserRecurringPayment = (id, paymentType) => (dispatch) => {

    return ApiService.get(`paypal/${paymentType || PAYMENT_TYPE_MEMBERSHIP}/${id}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error)
        })
};


export const insertPayment = (paymentModel) => (dispatch) => {
    return ApiService.post("paypal/insertPayment", paymentModel)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error)
        })
};

export const encryptDecryptId = (id, isEncrypt) => (dispatch) => {

    const params = new FormData();
    params.append("userId", id)
    params.append("isEncrypt", isEncrypt)

    return ApiService.post("user/encryptDecryptId", params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error)
        })
};